import { render } from "./RealRegReceipt.vue?vue&type=template&id=16e9d462&scoped=true"
import script from "./RealRegReceipt.vue?vue&type=script&lang=js"
export * from "./RealRegReceipt.vue?vue&type=script&lang=js"

import "./RealRegReceipt.vue?vue&type=style&index=0&id=16e9d462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e9d462"]])

export default __exports__